export default __webpack_public_path__ + "static/media/fex-application.00dfb2b4.png";